import {
  GET_USERS,
  GET_INVITES,
  GET_PUBLISHERS,
  GET_BUYERS,
  GET_USER_SETTINGS,
  GET_USER_VISIBLE_COLUMNS,
  INVITE_USER,
  DELETE_USER,
  DELETE_INVITE
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getUsersStatus = state => state.status[getActionStatusName(GET_USERS)] || {};
export const getInvitesStatus = state => state.status[getActionStatusName(GET_INVITES)] || {};
export const getPublishersStatus = state => state.status[getActionStatusName(GET_PUBLISHERS)] || {};
export const getBuyersStatus = state => state.status[getActionStatusName(GET_BUYERS)] || {};
export const getUserSettingsStatus = state => state.status[getActionStatusName(GET_USER_SETTINGS)] || {};
export const getUserVisibleColumnsStatus = state => state.status[getActionStatusName(GET_USER_VISIBLE_COLUMNS)] || {};
export const inviteUserStatus = state => state.status[getActionStatusName(INVITE_USER)] || {};
export const deleteUserStatus = state => state.status[getActionStatusName(DELETE_USER)] || {};
export const deleteInviteStatus = state => state.status[getActionStatusName(DELETE_INVITE)] || {};
